import { useEffect } from 'react'
import Intercom from '@intercom/messenger-js-sdk'
import { useAuth } from '../contexts/auth-context'

export const IntercomComponent = () => {
  const { user } = useAuth()

  useEffect(() => {
    // Initialize Intercom with your app ID
    Intercom({
      app_id: 'mpdimn2a',
      user_id: user?.id,
      name: user?.name,
      email: user?.email,
      created_at: user?.createdAt ? Math.floor(new Date(user.createdAt).getTime() / 1000) : undefined,
      company: user?.company ? {
        id: user.company,
        name: user.company
      } : undefined,
      custom_attributes: {
        role: user?.role,
        subscription_status: user?.subscriptionStatus,
        subscription_plan: user?.subscriptionPlan,
      }
    })

    // Update user data when user changes
    if (user) {
      Intercom({
        app_id: 'mpdimn2a',
        user_id: user.id,
        name: user.name,
        email: user.email,
        created_at: user.createdAt ? Math.floor(new Date(user.createdAt).getTime() / 1000) : undefined,
        company: user.company ? {
          id: user.company,
          name: user.company
        } : undefined,
        custom_attributes: {
          role: user.role,
          subscription_status: user.subscriptionStatus,
          subscription_plan: user.subscriptionPlan,
        }
      })
    }

    return () => {
      // Cleanup on unmount
      if (typeof window !== 'undefined' && window.Intercom) {
        window.Intercom('shutdown')
      }
    }
  }, [user])

  // Show/hide messenger based on authentication
  useEffect(() => {
    if (user && typeof window !== 'undefined' && window.Intercom) {
      window.Intercom('show')
    } else if (typeof window !== 'undefined' && window.Intercom) {
      window.Intercom('hide')
    }
  }, [user])

  return null // This component doesn't render anything visible
}

// Helper functions for manual control
export const showIntercom = () => {
  if (typeof window !== 'undefined' && window.Intercom) {
    window.Intercom('show')
  }
}

export const hideIntercom = () => {
  if (typeof window !== 'undefined' && window.Intercom) {
    window.Intercom('hide')
  }
}

export const showIntercomMessages = () => {
  if (typeof window !== 'undefined' && window.Intercom) {
    window.Intercom('showMessages')
  }
}

export const showIntercomNewMessage = (message?: string) => {
  if (typeof window !== 'undefined' && window.Intercom) {
    if (message) {
      window.Intercom('showNewMessage', message)
    } else {
      window.Intercom('showNewMessage')
    }
  }
}

export const trackIntercomEvent = (eventName: string, metadata?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.Intercom) {
    window.Intercom('trackEvent', eventName, metadata)
  }
}

// Predefined event tracking functions for common actions
export const trackRfpCreated = (rfpData: { id: string, title: string, category: string, budget?: number }) => {
  trackIntercomEvent('rfp-created', rfpData)
}

export const trackRfpShared = (rfpData: { id: string, title: string, platform: string }) => {
  trackIntercomEvent('rfp-shared', rfpData)
}

export const trackResponseSubmitted = (responseData: { rfpId: string, rfpTitle: string, budget?: number }) => {
  trackIntercomEvent('response-submitted', responseData)
}

export const trackSubscriptionUpgraded = (subscriptionData: { plan: string, price?: number }) => {
  trackIntercomEvent('subscription-upgraded', subscriptionData)
}

export const trackLinkedInConnected = () => {
  trackIntercomEvent('linkedin-connected')
}
